import { List } from 'immutable';
import { utilityBillConstants, uboConstants, directorConstants } from '../constants';
import { setUtilityBillEntityId } from './helpers';
import {
  createCirculationContact,
  editCirculationContact
} from '../features/kyc/circulationContactsSlice';

export function utility_bills(state = {}, action) {
  switch (action.type) {
    case utilityBillConstants.UTILITY_BILL_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case utilityBillConstants.UTILITY_BILL_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case utilityBillConstants.UTILITY_BILL_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case utilityBillConstants.UTILITY_BILL_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case utilityBillConstants.UTILITY_BILL_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case utilityBillConstants.UTILITY_BILL_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case utilityBillConstants.UTILITY_BILL_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case utilityBillConstants.UTILITY_BILL_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const utilityBillIndex = state.items.findIndex(val => val.id == action.response.id);

      if (utilityBillIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(utilityBillIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case utilityBillConstants.UTILITY_BILL_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case utilityBillConstants.UTILITY_BILL_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case utilityBillConstants.UTILITY_BILL_DELETE_SUCCESS: {
      const { utilityBillId } = action;

      if (!state.items) {
        return state;
      }

      const utilityBillIndex = state.items.findIndex(val => val.id == utilityBillId);

      if (utilityBillIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(utilityBillIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case uboConstants.UBO_EDIT_SUCCESS:
    case uboConstants.UBO_CREATE_SUCCESS: {
      return setUtilityBillEntityId(state, action, 'uboId');
    }
    case directorConstants.DIRECTOR_EDIT_SUCCESS:
    case directorConstants.DIRECTOR_CREATE_SUCCESS: {
      return setUtilityBillEntityId(state, action, 'directorId');
    }
    case [createCirculationContact.fulfilled]:
    case [editCirculationContact.fulfilled]: {
      return setUtilityBillEntityId(state, action, 'contactId');
    }
    case utilityBillConstants.UTILITY_BILL_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case utilityBillConstants.UTILITY_BILL_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
